import { WalletConnectDialog as ToolkitWalletConnect } from "@sundaeswap/ui-toolkit";
import {
  IWindowCip30Extension,
  useWalletObserver,
} from "@sundaeswap/wallet-lite";
import { FC, useCallback, useState } from "react";

import { WalletConnectLegalDisclaimer } from "./WalletConnectLegalDisclaimer";
import { NoWalletsIndicator } from "./NoWalletsIndicator";

interface IWalletConnectDialogProps {
  open: boolean;
  onClose: () => void;
  treatAsDisconnected?: boolean;
}

export const WalletConnectDialog: FC<IWalletConnectDialogProps> = ({
  open,
  onClose,
  treatAsDisconnected = false,
}) => {
  const { activeWallet, connectWallet } = useWalletObserver();
  const [isConnecting, setIsConnecting] = useState(false);

  const handleConnect = useCallback(
    async (name: string, _ref: IWindowCip30Extension) => {
      setIsConnecting(true);
      try {
        await connectWallet(name);
      } catch (e) {
        // Wallet connected but sync may have failed (e.g. getBalance error).
        // Still close the dialog — the wallet is usable, just balance may be 0.
        console.warn("Wallet sync error (connection still active):", e);
      } finally {
        setIsConnecting(false);
        onClose();
      }
    },
    [connectWallet, onClose],
  );

  return (
    <ToolkitWalletConnect
      i18n={{
        description: "Select a wallet to connect to Sugar Rush.",
        title: "Connect Wallet",
        walletConnect: "Connect Wallet",
        noWallets: "No wallets detected",
        selectWalletNotice: "Please select a wallet to connect.",
        selectWalletNoticeTitle: "No wallet selected",
      }}
      legalDisclaimer={<WalletConnectLegalDisclaimer />}
      isLoading={isConnecting}
      isWalletConnected={treatAsDisconnected ? false : !!activeWallet}
      noWalletsComponent={<NoWalletsIndicator />}
      onConnectWallet={handleConnect}
      onClose={onClose}
      open={open}
    />
  );
};

export default WalletConnectDialog;
